export default __webpack_public_path__ + "static/media/APIFriends.e74b66fd.jpg";